import { TableBodyCell, TableCellEmpty, TableCellText } from '@pocketlaw/tetris';
import { localizedFormatDate } from 'shared/domains/common-utils';
export function DateCell(props) {
    const { date, headers } = props;
    const formatted = localizedFormatDate(date, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
    return (<TableBodyCell headers={headers}>
      {formatted ? <TableCellText primary={formatted}/> : <TableCellEmpty />}
    </TableBodyCell>);
}
